import { defineMessages } from 'react-intl'

export const VALUE_PROPS_TITLES = defineMessages({
  mentalHealthSessions: {
    defaultMessage: '1-on-1 mental health sessions for you and your family',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  condensedMentalHealthSessions: {
    defaultMessage: '1-on-1 mental health sessions',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  meditationsCoursesArticles: {
    defaultMessage: 'Meditations, courses, articles, and more wellness resources',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  condensedMeditationsCoursesArticles: {
    defaultMessage: 'Meditations, courses, and more',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  dedicatedSupport: {
    defaultMessage: 'Dedicated support, anytime day or night',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  condensedDedicatedSupport: {
    defaultMessage: 'Dedicated support, anytime',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  providersIntelligentlyMatched: {
    defaultMessage: 'Providers intelligently matched to your needs',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
})

export const MENTAL_HEALTH_SESSIONS_VALUE_PROPS = defineMessages({
  sessionCountContent: {
    defaultMessage:
      '{numberOfSessions} free sessions per year{dependentsEnabled, select, yes { for you and your dependents} other {}}–covered by {customerDisplayName}',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  defaultContent: {
    defaultMessage: '1-on-1 mental health sessions{dependentsEnabled, select, yes { for you and your family} other {}}',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
})

export const VALUE_PROPS_TITLES_LYRA_SELECT = defineMessages({
  onDemandContent: {
    defaultMessage: 'On-demand meditations, videos, and more',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  personalizedCare: {
    defaultMessage: 'Personalized care with resources to match your goals',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  mentalHealthSessions: {
    defaultMessage: '1-on-1 coaching and therapy sessions, at no cost',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  dedicatedSupport: {
    defaultMessage: 'Get in touch, anytime day or night',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
})

export const VALUE_PROPS_TITLES_GOOGLE_CRITICAL_TALENT = defineMessages({
  coachingSessions: {
    defaultMessage: '1-on-1 sessions with a Google Talent performance coach, plus more care options',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  onDemandContent: {
    defaultMessage: 'On-demand tools from the Performance Accelerator Lab to boost your productivity',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
  dedicatedSupport: {
    defaultMessage: 'Concierge-level support from a Lyra Care Navigator',
    description: 'Value prop item, under a header like "What you get with Lyra:"',
  },
})

export const VALUE_PROPS_TITLES_DBT = defineMessages({
  toolsForResilientLife: {
    defaultMessage: 'Learn mindfulness, distress tolerance, emotional regulation, and healthy relationships.',
    description: 'DBT value prop item, under a header like "How our DBT program supports your mental health:"',
  },
  goldStandard: {
    defaultMessage:
      'Receive the highest level of care designed specifically for rapid symptom reduction and lasting stability.',
    description: 'DBT value prop item, under a header like "How our DBT program supports your mental health:"',
  },
  feelBetterFaster: {
    defaultMessage: 'Get connected to care quickly, when you need it the most.',
    description: 'DBT value prop item, under a header like "How our DBT program supports your mental health:"',
  },
})
